<template>
  <!--上传下载generic-->
  <div id="addSoToWave">
     <a-modal
            :title="$t('pubGicSet.addSoToWave') "
            :visible="visible"
            width="60%"
            @cancel="cancelModal"
            :maskClosable="maskClosable"
            cancelText="-"
            okText="-"
            :footer="null"
    >

      <!-- <template slot="footer">
        <a-button type="primary"  @click="assignSave">{{ $t('publicLang.Save') }}</a-button>
      </template> -->

        <a-row type="flex" justify="space-between" >

            <a-col>                  
                <a-button size="small" class="mg5" style="width: 80px;" @click="queryWave"> {{$t('pubGicSet.query')}}</a-button>
                <a-button size="small" class="mg5" style="width: 80px;" @click="resetQueryCondition">{{$t('pubGicSet.reset')}}</a-button>
                <a-button size="small" class="mg5" style="width: 80px;" @click="assignSave">{{$t('pubGicSet.save')}}</a-button>
            </a-col>

      
        </a-row>


 <a-form :form="waveQueryForm" style="margin-bottom: 10px">
  <a-row type="flex" justify="center">
    <a-col :span="7">
            <a-form-item :label="$t('pubGicSet.waveId')"   v-bind="formItemLayout" style="margin-bottom: 0px">
                      <a-input                      
                      size="small"  
                        v-decorator="[
                                'waveId',
                                { initialValue: this.searchInfo. waveId}
                                 ]"
                          />
            </a-form-item>

       
                   <a-form-item :label="$t('pubGicSet.ref03')" name="esdaName" v-bind="formItemLayout" style="margin-bottom: 0px"
         >
           <a-input size="small"  
            v-decorator="[
                     'ref03',
                     {
                        initialValue: this.searchInfo.ref03}
                   ]"   />
         </a-form-item>



    </a-col> 



    <a-col :span="7" style="margin-bottom: 0px">

     <a-form-item :label="$t('pubGicSet.ref01')"  v-bind="formItemLayout" style="margin-bottom: 0px">
              <a-input size="small"            
                v-decorator="[
                        'ref01',
                        {
                            initialValue: this.searchInfo. ref01,
                            }
                         ]"
                      
                  />
            </a-form-item>

         <a-form-item :label="$t('pubGicSet.ref04')" name="esdaNameEn" v-bind="formItemLayout" style="margin-bottom: 0px">
           <a-input size="small"     
            v-decorator="[
                     'ref04',
                     {
                       initialValue: this.searchInfo. ref04
                    }
                   ]"  />
         </a-form-item>

    </a-col>

    <a-col :span="7" style="margin-bottom: 0px">

            <a-form-item  size="small" :label="$t('pubGicSet.ref02')" name="esdaType" v-bind="formItemLayout"  style="margin-bottom: 0px">
                 <a-input size="small"            
                     v-decorator="[
                        'ref02',
                        {
                            initialValue: this.searchInfo. ref01
                           }
                         ]"
                      
                  />
              </a-form-item>

        <a-form-item :label="$t('pubGicSet.ref05')" name="esdaDesc" v-bind="formItemLayout" style="margin-bottom: 0px">
          <a-input size="small"     
           v-decorator="[
                    'ref05',
                    {
                      initialValue: this.searchInfo. ref05
                    }
                  ]"  />
        </a-form-item> 

    </a-col>
  </a-row> 
</a-form>








       <a-row type="flex" justify="space-between" style="margin-bottom: 6px;">
          <a-col> 
          </a-col>
          <a-col>
            <a-row type="flex" justify="start">
              <a-col>
                <a-pagination :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                    size="small"
                    :total="pagingTotal"
                    v-model="currentVal"
                    :pageSize.sync="pagingSize"
                    @change="tableChangePage"
                    @showSizeChange="onShowSizeChange"
                    showSizeChanger

                />
              </a-col>
            </a-row>
          </a-col>
        </a-row>



      <div>

        <vxe-table               
                   stripe
                   border
                   highlight-hover-row
                   show-header-overflow
                   show-overflow
                   resizable
                   :data.sync="waveTable"
                   size="mini"
                   max-height="350"
                   :loading="parloading"
                   @header-cell-dblclick="headerCellDbclick"
                   ref="importTableRefs"
              >
            <template v-slot:empty>
              <span style="font-size: 12px;">{{ $t('pubGicSet.NoRecordfound') }}</span>
            </template>

            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
              
                   <vxe-table-column
                       field="waveId"
                       width="200">
                     <template v-slot:header="{ column }">
                       <span>{{ $t('pubGicSet.waveId') }}</span>
                       <div style="display: flex;align-items: center" v-if="isHeaderSearchFlag">
                         <input
                             type="text"
                             :placeholder="$t('publicLang.PleaseEnter')"
                             style="width: 50%;border-right: none;"
                             v-model="searchInfo.waveId"
                             @keyup.enter="searchTitleCont"/>
                         <span style="background: #fff;border: 1px solid #efefef;padding: 0 2px;cursor:pointer">
                             <a-icon type="search"  @click="searchTitleCont"/>
                         </span>
                       </div>
                     </template>
                   </vxe-table-column>



                      <vxe-table-column
                       field="ref01"
                       width="200">
                     <template v-slot:header="{ column }">
                       <span>{{ $t('pubGicSet.ref01') }}</span>
                       <div style="display: flex;align-items: center" v-if="isHeaderSearchFlag">
                         <input
                             type="text"
                             :placeholder="$t('publicLang.PleaseEnter')"
                             style="width: 50%;border-right: none;"
                             v-model="searchInfo.ref01"
                             @keyup.enter="searchTitleCont"/>
                         <span style="background: #fff;border: 1px solid #efefef;padding: 0 2px;cursor:pointer">
                             <a-icon type="search"  @click="searchTitleCont"/>
                         </span>
                       </div>
                     </template>
                   </vxe-table-column>



      <vxe-table-column
                       field="ref02"
                       width="200">
                     <template v-slot:header="{ column }">
                       <span>{{ $t('pubGicSet.ref02') }}</span>
                       <div style="display: flex;align-items: center" v-if="isHeaderSearchFlag">
                         <input
                             type="text"
                             :placeholder="$t('publicLang.PleaseEnter')"
                             style="width: 50%;border-right: none;"
                             v-model="searchInfo.ref02"
                             @keyup.enter="searchTitleCont"/>
                         <span style="background: #fff;border: 1px solid #efefef;padding: 0 2px;cursor:pointer">
                             <a-icon type="search"  @click="searchTitleCont"/>
                         </span>
                       </div>
                     </template>
                   </vxe-table-column>






      <vxe-table-column
                       field="ref03"
                       width="200">
                     <template v-slot:header="{ column }">
                       <span>{{ $t('pubGicSet.ref03') }}</span>
                       <div style="display: flex;align-items: center" v-if="isHeaderSearchFlag">
                         <input
                             type="text"
                             :placeholder="$t('publicLang.PleaseEnter')"
                             style="width: 50%;border-right: none;"
                             v-model="searchInfo.ref03"
                             @keyup.enter="searchTitleCont"/>
                         <span style="background: #fff;border: 1px solid #efefef;padding: 0 2px;cursor:pointer">
                             <a-icon type="search"  @click="searchTitleCont"/>
                         </span>
                       </div>
                     </template>
                   </vxe-table-column>


      <vxe-table-column
                       field="ref04"
                       width="200">
                     <template v-slot:header="{ column }">
                       <span>{{ $t('pubGicSet.ref04') }}</span>
                       <div style="display: flex;align-items: center" v-if="isHeaderSearchFlag">
                         <input
                             type="text"
                             :placeholder="$t('publicLang.PleaseEnter')"
                             style="width: 50%;border-right: none;"
                             v-model="searchInfo.ref04"
                             @keyup.enter="searchTitleCont"/>
                         <span style="background: #fff;border: 1px solid #efefef;padding: 0 2px;cursor:pointer">
                             <a-icon type="search"  @click="searchTitleCont"/>
                         </span>
                       </div>
                     </template>
                   </vxe-table-column>


      <vxe-table-column                    
                       field="ref05"
                       width="200">
                     <template v-slot:header="{ column }">
                       <span>{{ $t('pubGicSet.ref05') }}</span>
                       <div style="display: flex;align-items: center" v-if="isHeaderSearchFlag">
                         <input
                             type="text"
                             :placeholder="$t('publicLang.PleaseEnter')"
                             style="width: 50%;border-right: none;"
                             v-model="searchInfo.ref05"
                             @keyup.enter="searchTitleCont"/>
                         <span style="background: #fff;border: 1px solid #efefef;padding: 0 2px;cursor:pointer">
                             <a-icon type="search"  @click="searchTitleCont"/>
                         </span>
                       </div>
                     </template>
                   </vxe-table-column>


   


          </vxe-table>
      </div>


    </a-modal>


   

  </div>
</template>
<script>







    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import axios from "axios";
    import cookie from "../../../api/cookie";

    export default {
        components: {

        },
        props: {
            visible: {
                type: Boolean,
                default: function() {
                    return false;
                }
            },
            importparams: {
                type: Array,
                default: function() {
                    return [];
                }
            }
        },
        watch: {
            importparams(val) {
                this.initData();
            }
        },
        data() {
            return {
                waveQueryForm: this.$form.createForm(this),
                searchInfo:{},
                parloading: false, // 表格加载
                pagingTotal: 0, // 总条数
                currentVal: 1, // 当前页数
                pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'),  // 显示条数
                waveTable: [], // table 数据
                // dataImport: {}, // 请求import 数据
                maskClosable: false, // 关闭遮罩
                isHeaderSearchFlag: false,
                 formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            };
        },
        destroyed() {
            if (this.sortable) {
                this.sortable.destroy();
            }
        },
        methods: {
         queryWave(){
              this.waveQueryForm.validateFields((err, values) => {
                for (let key in values) {              
                    this.searchInfo[key] =  values[key];               
                }
              })
               this.initData();
         },
         resetQueryCondition(){
                this.waveQueryForm.resetFields()     
                this.searchInfo = {};
         },
          assignSave(){
              let updateRecords = this.$refs.importTableRefs.getCheckboxRecords()
              if (updateRecords.length != 1) {
                  this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3);
                  return;
              }

              let params = {
                  relIds: this.importparams,
                  waveId: updateRecords[0].waveId
              }
              ajax.post(api.SAVESOWAVE,params).then(res=>{
                  if(res.code == 200){                
                      this.$message.success(res.msg)
                      this.resetQueryCondition();
                      this.$emit("cancelImport", "init");     
                  }else{
                     this.$customMessage.warning(res.msg, 3);
                  return;
                  }
              })
          },
//      表头search
            headerCellDbclick(){
                this.isHeaderSearchFlag = !this.isHeaderSearchFlag
            },

            searchTitleCont(){
                //  this.isHeaderSearchFlag = false;
                this.currentVal = 1;
                this.initData();
            },



            //      分页事件start
            tableChangePage(current) {
                this.currentVal = current;
                this.initData();
            },
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.initData();
            },
            //      分页事件end
            //            获取弹窗表格数据
            initData() {
            
                let params = {};
                params.pageNum = this.currentVal;
                params.pageSize = this.pagingSize;
                params.waveId = this.searchInfo.waveId;
                params.ref01 = this.searchInfo.ref01;
                params.ref02 = this.searchInfo.ref02;
                params.ref03 = this.searchInfo.ref03;
                params.ref04 = this.searchInfo.ref04;
                params.ref05 = this.searchInfo.ref05;

                 ajax.get(api.GETSOWAVE,params).then(res=>{
                         if (res.code == 200) {
                                  this.waveTable = res.data.list
                                  this.pagingTotal =res.data.total
                             } else {
                             this.$customMessage.warning(res.msg, 3);
                         }
                    })
            },
          
            //      import 编辑弹窗返回值
            // GETcancelModalVisible(val) {
            //    this.searchInfo={}
            //     this.waveQueryForm.resetFields();
            //     this.eddvisible = false;
            //     this.$emit("cancelImport", "init");
            // },

            //            弹窗取消
            cancelModal() {
                this.searchInfo={}
                this.waveQueryForm.resetFields();
                this.$emit("cancelImport", "close");
            },
        }
    };
</script>
<style lang="less">
.bgc{
     background-color: #2b9ed6;
}
  .example {
    text-align: center;
    border-radius: 4px;
    padding: 80px 50px;
    margin: 20px 0;
  }
</style>
